
export class Image
{
    id: number;
    fileName: string;
    imageBase64: string;
    creationDate: Date;
}


// WEBPACK FOOTER //
// ./src/app/+common/model/image.model.ts